import { render, staticRenderFns } from "./ModalSucesso.vue?vue&type=template&id=c12b49d4"
import script from "./ModalSucesso.vue?vue&type=script&lang=js"
export * from "./ModalSucesso.vue?vue&type=script&lang=js"
import style0 from "./ModalSucesso.vue?vue&type=style&index=0&id=c12b49d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports